export default "<link rel=\"stylesheet\" type=\"text/css\" href=\"/front_pc/src/css/main.css\">"